module.exports = __webpack_public_path__ + "static/media/django.876501a0.svg";